import { render, staticRenderFns } from "./OrderInfoSidebar.vue?vue&type=template&id=cb41f5ae&scoped=true&"
import script from "./OrderInfoSidebar.vue?vue&type=script&lang=js&"
export * from "./OrderInfoSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb41f5ae",
  null
  
)

export default component.exports